// extracted by mini-css-extract-plugin
export var avatarContainer = "_fg-0";
export var avatarTypingWave = "_fg-i";
export var gray = "_fg-f";
export var green = "_fg-c";
export var icon = "_fg-9";
export var image = "_fg-1";
export var lg = "_fg-6";
export var md = "_fg-5";
export var presenceDot = "_fg-b";
export var red = "_fg-d";
export var sm = "_fg-4";
export var status = "_fg-a";
export var typingDot = "_fg-h";
export var typingPill = "_fg-g";
export var xl = "_fg-7";
export var xs = "_fg-3";
export var xxl = "_fg-8";
export var xxs = "_fg-2";
export var yellow = "_fg-e";